import { Routes } from '@angular/router';

import { authGuard, loginGuard } from './core/route-guards';

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () => import('./home/home-routes'),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
  },
  { path: 'login', loadComponent: () => import('./login/login.component'), canActivate: [loginGuard] },
  { path: 'callback', loadChildren: () => import('./callback/callback-routes') },
  { path: 'not-found', loadComponent: () => import('./not-found/not-found.component') },
  { path: 'forbidden', loadComponent: () => import('./forbidden/forbidden.component') },
  { path: '**', redirectTo: 'not-found' },
];
